import { render, staticRenderFns } from "./ModificarEncuestas.vue?vue&type=template&id=28f0d8c6&scoped=true&"
import script from "./ModificarEncuestas.vue?vue&type=script&lang=js&"
export * from "./ModificarEncuestas.vue?vue&type=script&lang=js&"
import style0 from "./ModificarEncuestas.vue?vue&type=style&index=0&id=28f0d8c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f0d8c6",
  null
  
)

export default component.exports